import React from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import CancelButton from "presentation/components/buttons/cancel";


class EvaluationTypeForm extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        let { loading, form, handleChange, handleSubmit, component } = this.props;
        return (
            <Form>
                <h4>Informações de tipo de avaliação</h4>
                <div className="form">
                    <Form.Label htmlFor="name">Nome</Form.Label>
                    <Form.Control
                        type="text"
                        id="name"
                        name="name"
                        defaultValue={form.name}
                        onChange={(e) => handleChange(e, component)}
                        aria-describedby="nameHelpBlock"
                    />
                    <Form.Text id="nameHelpBlock" muted>
                        Informe o tipo de tipo de avaliação
                    </Form.Text>
                </div>
                <div className="form mt-2">
                    <Form.Label htmlFor="machineName">Token</Form.Label>
                    <Form.Control
                        type="text"
                        id="machineName"
                        name="machineName"
                        defaultValue={form.machineName}
                        onChange={(e) => handleChange(e, component)}
                        aria-describedby="dmachineNameHelpBlock"
                    />
                    <Form.Text id="machineNameHelpBlock" muted>
                        Token que será utilizado nas fórmulas
                    </Form.Text>
                </div>
                <div className="mt-3">
                    <CancelButton
                        containerProps={{
                            as: Link,
                            to: `/tipos-avaliacao`
                        }}
                    />
                    <Button disabled={loading} variant="success" className="float-end" onClick={() => handleSubmit()}>Salvar</Button>
                </div>
            </Form>
        );
    };
}

export default EvaluationTypeForm;